import React, { Component } from 'react'

export default class HelpVideo extends Component {
  state = {
    open: false
  }

  handleShow = event => {
    event.preventDefault()
    this.setState({ open: true })
  }

  render() {
    const { open } = this.state
    const { url } = this.props

    if (!url) {
      return null
    }

    if (open) {
      return (
        <div style={{margin: '10px 0', textAlign: 'center'}}>
          <iframe 
            src={url}
            width="640"
            height="410"
            frameBorder="0"
            allowFullScreen />
        </div>
      )
    } else {
      return (
        <button onClick={this.handleShow}>Watch How To Video</button>
      )
    }
  }
}


// WEBPACK FOOTER //
// client/components/sections/Integrations/HelpVideo.js